if (typeof window.initProductMediaGallery !== "function") {
  window.initProductMediaGallery = function initProductMediaGallery(section) {
    const allowedSections = ["product-section", "featured-product-section"];

    if (
      !section ||
      !allowedSections.some((cls) => section.classList.contains(cls))
    ) {
      return;
    }

    // Teardown registry keyed on the section root so re-init and unload can
    // destroy every Swiper / observer / listener created for that section.
    const registerCleanup = (root, fn) => {
      (root._mediaGalleryCleanup = root._mediaGalleryCleanup || []).push(fn);
    };

    const teardown = (root) => {
      if (!root || !root._mediaGalleryCleanup) return;
      root._mediaGalleryCleanup.forEach((fn) => fn());
      root._mediaGalleryCleanup = [];
    };

    const initMainSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sliderEl = section.querySelector(".js-media-list");
      if (!sliderEl) return;

      const desktopType = sliderEl.dataset?.desktopType || "slider_previews";
      const mobileType = sliderEl.dataset?.mobileType || "slider_previews";
      const buttonPrev = sliderEl.querySelector(".slider-nav-button--prev");
      const buttonNext = sliderEl.querySelector(".slider-nav-button--next");
      const paginationEl = sliderEl.querySelector(".slider-pagination");
      const mediaBox = sliderEl.closest(".product__media");
      const thumbsSlider = mediaBox?.querySelector(".js-media-sublist");
      const wrapperEl = sliderEl.querySelector(".swiper-wrapper");

      // Disable loop and set speed to 0 for large slide counts to reduce DOM overhead.
      const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;
      const isLoop = slideCount > 1 && slideCount <= 32;
      const speed = slideCount > 32 ? 0 : 800;

      const isInfoOverlay = Boolean(
        mediaBox?.classList.contains("product__media--info-overlay")
      );

      const desktopQuery = window.matchMedia("(min-width: 990px)");

      // Autoplay drifts the media like a ticker: zero delay + a long linear
      // transition (the timing function comes from the --autoplay modifier CSS).
      const hasAutoplay =
        sliderEl.dataset?.autoplay === "true" &&
        slideCount > 1 &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const driftSpeed = 5000;
      const autoplayOptions = hasAutoplay
        ? {
            delay: 1,
            disableOnInteraction: false,
          }
        : false;

      const desktopPerView = isInfoOverlay ? 2.5 : 1;
      const loopMinimum = Math.ceil(desktopPerView) + 1;
      const extraSets =
        (hasAutoplay || isLoop) && slideCount > 1 && slideCount < loopMinimum
          ? Math.ceil(loopMinimum / slideCount) - 1
          : 0;
      const slideSources = extraSets
        ? Array.from(
            wrapperEl.querySelectorAll(":scope > .swiper-slide"),
            (slide) => slide.cloneNode(true)
          )
        : [];

      const cloneSlide = (slide, set) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute("data-media-clone", "");
        clone.setAttribute("aria-hidden", "true");
        clone.querySelectorAll("[id]").forEach((el) => {
          el.id = `${el.id}-copy-${set}`;
        });
        clone
          .querySelectorAll(
            "a[href], button, input, select, textarea, [tabindex]"
          )
          .forEach((el) => el.setAttribute("tabindex", "-1"));
        return clone;
      };

      const removeClones = () => {
        wrapperEl
          ?.querySelectorAll(":scope > [data-media-clone]")
          .forEach((clone) => clone.remove());
      };

      const buildClones = () => {
        const clones = [];
        for (let set = 1; set <= extraSets; set += 1) {
          slideSources.forEach((slide) => clones.push(cloneSlide(slide, set)));
        }
        return clones;
      };

      const syncClones = () => {
        removeClones();
        if (!extraSets || !desktopQuery.matches) return;
        wrapperEl.append(...buildClones());
      };

      const syncLiveClones = () => {
        const swiper = sliderEl.swiper;
        if (!extraSets || !swiper || swiper.destroyed) return;

        const cloneCount = wrapperEl.querySelectorAll(
          ":scope > [data-media-clone]"
        ).length;

        if (desktopQuery.matches && !cloneCount) {
          swiper.appendSlide(buildClones());
        } else if (!desktopQuery.matches && cloneCount) {
          swiper.removeSlide(
            Array.from({ length: cloneCount }, (_, i) => slideCount + i)
          );
        }
      };

      const destroyHold = () => {
        sliderEl._mediaHold?.destroy();
        sliderEl._mediaHold = null;
      };

      const syncAutoplay = () => {
        const swiper = sliderEl.swiper;
        if (!swiper || !hasAutoplay) return;

        if (desktopQuery.matches) {
          swiper.autoplay?.start();
        } else {
          swiper.autoplay?.stop();
        }
      };

      const initSwiper = () => {
        destroyHold();
        syncClones();
        new Swiper(sliderEl, {
          slidesPerView: 1,
          spaceBetween: 1,
          autoHeight: false,
          loop: isLoop,
          direction: "horizontal",
          speed: speed,
          autoplay: autoplayOptions,
          allowTouchMove: true,
          watchSlidesProgress: true,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: buttonNext,
            prevEl: buttonPrev,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
            990: {
              slidesPerView: isInfoOverlay ? 2.5 : 1,
              loop: hasAutoplay ? true : isLoop,
              speed: hasAutoplay ? driftSpeed : speed,
            },
          },
          thumbs: {
            swiper: thumbsSlider?.swiper ? thumbsSlider.swiper : "",
            //autoScrollOffset: 1,
            multipleActiveThumbs: false,
            slideThumbActiveClass: "swiper-slide-thumb-active",
          },
          a11y: {
            slideLabelMessage: `{{index}} / ${slideCount}`,
          },
          on: {
            breakpoint: function () {
              syncAutoplay();
              syncLiveClones();
            },
            autoplayStop: function () {
              this.params.speed = speed;
            },
            slideChange: function () {
              window.pauseAllMedia(sliderEl);
              this.params.noSwiping = false;

              if (thumbsSlider?.swiper) {
                const activeIndex = this.params.loop
                  ? this.realIndex % slideCount
                  : this.activeIndex;
                thumbsSlider.swiper.slideTo(activeIndex);
              }
            },
            slideChangeTransitionEnd: function () {
              const activeSlide = this.slides[this.activeIndex];
              const model3D = activeSlide?.querySelector("model-viewer");
              const posterBtn3D = activeSlide?.querySelector(
                ".shopify-model-viewer-ui__button--poster"
              );
              if (model3D && posterBtn3D) {
                posterBtn3D.removeAttribute("hidden");
              }
            },
            touchEnd: function () {
              sliderEl._mediaHold?.set("touch", false);
            },
            touchStart: function () {
              sliderEl._mediaHold?.set("touch", true);

              const model3D =
                this.slides[this.activeIndex]?.querySelector("model-viewer");
              if (model3D) {
                if (
                  !model3D.classList.contains(
                    "shopify-model-viewer-ui__disabled"
                  )
                ) {
                  this.params.noSwiping = true;
                  this.params.noSwipingClass = "swiper-slide";
                } else {
                  this.params.noSwiping = false;
                }
              }
            },
          },
        });

        // The drift stops at once rather than after the step in flight, and
        // the pointer always holds it (there is no hover setting).
        if (hasAutoplay) {
          const swiper = sliderEl.swiper;
          const startAutoplay = swiper.autoplay.start;
          swiper.autoplay.start = () => {
            swiper.params.speed = driftSpeed;
            return startAutoplay();
          };

          sliderEl._mediaHold = holdSwiperAutoplay(
            swiper,
            mediaBox || sliderEl,
            { hoverTarget: sliderEl, freeze: true }
          );
        }

        syncAutoplay();
      };

      const destroySwiper = () => {
        destroyHold();
        if (sliderEl.swiper) {
          thumbsSlider?.swiper?.off("tap");
          sliderEl.swiper.destroy();
        }
        sliderEl.querySelectorAll(".swiper-wrapper").forEach((wrapper) => {
          wrapper.removeAttribute("style");
        });
        sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
          slide.removeAttribute("style");
        });
        removeClones();
      };

      const stepTicker = (direction) => {
        const swiper = sliderEl.swiper;
        if (!swiper || swiper.destroyed) return;
        if (swiper.animating && !swiper.autoplay?.running) return;

        sliderEl._mediaHold?.set("navigation", true);
        void swiper.wrapperEl.offsetWidth;

        const position = swiper.rtlTranslate
          ? swiper.translate
          : -swiper.translate;
        const offset = position - swiper.slidesGrid[swiper.activeIndex];

        if (Math.abs(offset) > 1) {
          const before =
            offset < 0 ? swiper.activeIndex - 1 : swiper.activeIndex;
          const target = Math.min(
            Math.max(direction > 0 ? before + 1 : before, 0),
            swiper.slides.length - 1
          );
          swiper.slideTo(target, speed);
        } else if (direction > 0) {
          swiper.slideNext(speed);
        } else {
          swiper.slidePrev(speed);
        }

        sliderEl._mediaHold?.set("navigation", false);
      };

      const onTickerNavClick = (event) => {
        const button = event.target.closest?.(".slider-nav-button");
        if (!button || (button !== buttonNext && button !== buttonPrev)) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        stepTicker(button === buttonNext ? 1 : -1);
      };

      const hasDesktopSwiper =
        desktopType === "slider" || desktopType == "slider_previews";
      const hasMobileSwiper =
        mobileType === "slider" || mobileType == "slider_previews";

      let resizeObserver = null;
      if (hasDesktopSwiper && hasMobileSwiper) {
        initSwiper();
      } else {
        // Any resize fires this; init only when missing so instances never stack.
        resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (window.innerWidth >= 990 && hasDesktopSwiper) {
              if (!sliderEl.swiper) initSwiper();
              return;
            }

            if (window.innerWidth < 990 && hasMobileSwiper) {
              if (!sliderEl.swiper) initSwiper();
              return;
            }

            destroySwiper();
          });
        });

        resizeObserver.observe(section);
      }

      const onDesktopChange = () => {
        if (desktopQuery.matches) syncLiveClones();
        syncAutoplay();
      };

      desktopQuery.addEventListener("change", onDesktopChange);

      if (hasAutoplay) {
        sliderEl.addEventListener("click", onTickerNavClick, true);
      }

      registerCleanup(section, () => {
        desktopQuery.removeEventListener("change", onDesktopChange);
        sliderEl.removeEventListener("click", onTickerNavClick, true);
        if (resizeObserver) resizeObserver.disconnect();
        destroyHold();
        if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
        removeClones();
      });
    };

    const initSubSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sliderEl = section.querySelector(".js-media-sublist");
      if (!sliderEl) return;

      const desktopType = sliderEl.dataset?.desktopType || "slider_previews";
      const mobileType = sliderEl.dataset?.mobileType || "slider_previews";
      const hasDesktopSwiper = desktopType === "slider_previews";
      const hasMobileSwiper = mobileType === "slider_previews";
      const isRtlPage = document.documentElement.dir === "rtl";

      const initSwiper = () => {
        const thumbSlider = new Swiper(sliderEl, {
          spaceBetween: 1,
          slidesPerView: 4.5,
          loop: false,
          direction: "horizontal",
          allowTouchMove: true,
          watchSlidesProgress: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          autoHeight: false,
          slideToClickedSlide: true,
          on: {
            touchEnd: function (swiper) {
              let range = 5;
              let diff = (swiper.touches.diff = swiper.isHorizontal()
                ? swiper.touches.currentX - swiper.touches.startX
                : swiper.touches.currentY - swiper.touches.startY);
              if (diff < range || diff > -range) swiper.allowClick = true;
            },
          },
          breakpoints: {
            576: {
              slidesPerView: 4.5,
            },
            990: {
              slidesPerView: "auto",
              direction: "vertical",
              allowTouchMove: isRtlPage ? false : true,
            },
          },
        });

        return thumbSlider;
      };

      if (hasDesktopSwiper || hasMobileSwiper) {
        initSwiper();

        const resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (sliderEl.swiper) {
              if (window.innerWidth >= 990 && hasDesktopSwiper) {
                sliderEl.swiper.enable();
                sliderEl.swiper.changeDirection("vertical", true);
              }

              if (window.innerWidth < 990 && hasMobileSwiper) {
                sliderEl.swiper.enable();
                sliderEl.swiper.changeDirection("horizontal", true);
              }
            }
          });
        });

        resizeObserver.observe(section);

        registerCleanup(section, () => {
          resizeObserver.disconnect();
          if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
        });
      }
    };

    const initZoomSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sectionBox =
        section.querySelector('[id^="MainProduct-"]') ||
        section.querySelector('[id^="FeaturedProduct-"]');
      const sectionId = sectionBox?.dataset?.section;
      const sliderEl = document.querySelector(
        `[data-section-id='${sectionId}'].js-popup-slider`
      );
      if (!sliderEl) return;

      const buttonPrev = sliderEl.querySelector(".slider-nav-button--prev");
      const buttonNext = sliderEl.querySelector(".slider-nav-button--next");
      const paginationEl = sliderEl.querySelector(".slider-pagination");

      const isLoop = sliderEl.querySelectorAll(".swiper-slide").length > 1;

      const onMainSliderToggleClick = (event) => {
        if (!sliderEl.swiper) return;
        const zoomToggle = event.target.closest(".product__media-toggle");
        if (!zoomToggle) return;
        const mediaId = zoomToggle.dataset?.mediaId;
        if (!mediaId) return;
        sliderEl
          .querySelectorAll(".product-media-modal__item.swiper-slide")
          .forEach((slide, index) => {
            const zoomImageEl = slide.querySelector(
              `[data-media-id="${mediaId}"]`
            );
            if (zoomImageEl) {
              const findIndex = sliderEl.swiper.slides.findIndex(
                (slideEl) => slideEl.dataset?.mediaId === mediaId
              );
              const fallbackIndex = Number(
                slide.dataset?.swiperSlideIndex || index
              );
              const slideIndex = findIndex !== -1 ? findIndex : fallbackIndex;
              sliderEl.swiper.slideTo(slideIndex, 0);
              sliderEl.swiper.update();
            }
          });
      };

      new Swiper(sliderEl, {
        slidesPerView: 1,
        speed: 800,
        loop: isLoop,
        zoom: {
          maxRatio: 2,
        },
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: buttonNext,
          prevEl: buttonPrev,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        on: {
          afterInit: function () {
            section.querySelectorAll(".product__media-list").forEach((elem) => {
              elem.addEventListener("click", onMainSliderToggleClick);
            });
          },
          slideChange: function () {
            window.pauseAllMedia(sliderEl);
            this.params.noSwiping = false;
            sliderEl.classList.remove("zoom");
          },
          touchMove: function () {
            sliderEl.classList.remove("zoom");
          },
          slideChangeTransitionEnd: function () {
            const activeSlide = this.slides[this.activeIndex];
            const model3D = activeSlide?.querySelector("model-viewer");
            const posterBtn3D = activeSlide?.querySelector(
              ".shopify-model-viewer-ui__button--poster"
            );
            if (model3D && posterBtn3D) {
              posterBtn3D.removeAttribute("hidden");
            }
          },
          touchStart: function () {
            const model3D =
              this.slides[this.activeIndex]?.querySelector("model-viewer");
            if (model3D) {
              if (
                !model3D.classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });

      registerCleanup(section, () => {
        section.querySelectorAll(".product__media-list").forEach((elem) => {
          elem.removeEventListener("click", onMainSliderToggleClick);
        });
        if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
      });
    };

    const reinit = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }
      teardown(section);
      initSubSlider(section);
      initMainSlider(section);
      initZoomSlider(section);
    };

    reinit(section);

    if (!window.__themeProductMediaGalleryEvents) {
      window.__themeProductMediaGalleryEvents = true;

      document.addEventListener("shopify:section:load", (event) => {
        reinit(event.target);
      });

      document.addEventListener("shopify:section:unload", (event) => {
        teardown(event.target);
      });
    }
  };
}

if (typeof window.initProductPageElements !== "function") {
  window.initProductPageElements = function initProductPageElements(section) {
    const allowedSections = ["product-section", "featured-product-section"];

    if (
      !section ||
      !allowedSections.some((cls) => section.classList.contains(cls))
    ) {
      return;
    }

    // Teardown registry keyed on the section root so re-init and unload can
    // disconnect the sticky-bar observer created for that section.
    const registerCleanup = (root, fn) => {
      (root._pageElementsCleanup = root._pageElementsCleanup || []).push(fn);
    };

    const teardown = (root) => {
      if (!root || !root._pageElementsCleanup) return;
      root._pageElementsCleanup.forEach((fn) => fn());
      root._pageElementsCleanup = [];
    };

    const initStickyAddBar = (section) => {
      if (!section || !section.classList.contains("product-section")) {
        return;
      }

      const buyButtons = section.querySelector(
        ".product__buy-buttons > product-form"
      );
      const stickyBar = section.querySelector(".product-sticky-add-bar");
      const footerEl =
        document.querySelector(
          ".shopify-section-group-footer-group .footer__bottom"
        ) ||
        document.querySelector(
          ".shopify-section-group-footer-group .footer__top"
        );

      if (!stickyBar) return;

      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.01,
      };

      const isElementBelowScroll = (element) => {
        return element ? element.getBoundingClientRect().top > 0 : false;
      };

      // Re-queried per call: a variant change re-renders the buy-box quantity.
      const quantityInputs = () => ({
        main: section.querySelector(
          ".product__buy-buttons .product-form__quantity .quantity__input"
        ),
        sticky: stickyBar.querySelector(".quantity__input"),
      });

      const mirrorQuantity = (from, to) => {
        if (!from || !to || from.value === "" || to.value === from.value) {
          return;
        }
        to.value = from.value;
        to.closest("quantity-input")?.setMinimumDisable?.();
      };

      const toggleStickyBar = (isVisible) => {
        if (isVisible || isElementBelowScroll(buyButtons)) {
          stickyBar.classList.remove("active");
        } else {
          const { main, sticky } = quantityInputs();
          mirrorQuantity(main, sticky);
          stickyBar.classList.add("active");
        }
      };

      const handleIntersect = (entries) => {
        const isVisible = entries.some((entry) => entry.isIntersecting);
        toggleStickyBar(isVisible);
      };

      const observer = new IntersectionObserver(
        handleIntersect,
        observerOptions
      );

      if (buyButtons) observer.observe(buyButtons);
      if (footerEl) observer.observe(footerEl);

      registerCleanup(section, () => observer.disconnect());

      const onQuantityChange = (event) => {
        if (!event.target.closest) return;
        const input = event.target.closest(".quantity__input");
        if (!input) return;

        const { main, sticky } = quantityInputs();
        if (input === main) {
          mirrorQuantity(main, sticky);
        } else if (input === sticky) {
          mirrorQuantity(sticky, main);
        }
      };

      section.addEventListener("input", onQuantityChange);
      section.addEventListener("change", onQuantityChange);

      registerCleanup(section, () => {
        section.removeEventListener("input", onQuantityChange);
        section.removeEventListener("change", onQuantityChange);
      });
    };

    teardown(section);
    initStickyAddBar(section);

    if (!window.__themeProductPageElementsEvents) {
      window.__themeProductPageElementsEvents = true;

      document.addEventListener("shopify:section:load", (event) => {
        teardown(event.target);
        initStickyAddBar(event.target);
      });

      document.addEventListener("shopify:section:unload", (event) => {
        teardown(event.target);
      });
    }
  };
}

window.initProductMediaGallery(document.currentScript.parentElement);
window.initProductPageElements(document.currentScript.parentElement);
